import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  getOrganisationRoles,
  OrganisationRoleDto,
} from '../../users/api/userManagementApi';
import { useAuthStore } from '../../auth/stores/authStore';
import { userKeys } from '../../users/hooks/userKeys';

export function useOrganizationRoles(
  options?: Partial<UseQueryOptions<OrganisationRoleDto[], Error>>
) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: userKeys.roles(),
    queryFn: () => getOrganisationRoles(),
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000, // Roles don't change often, cache for 5 minutes
    ...options,
  });
}
